import alert from './alert.reducer';

export default alert;
